import layoutHeaderAside from '@/layout/header-aside'
const meta = { auth: true }
export default {
  path: '/robot/',
  name: '社群管家',
  meta,
  redirect: { name: 'robot-index' },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'index',
      name: `${pre}index`,
      component: () => import('@/views/robot/index'),
      meta: {
        title: '社群管家-运行情况'
      }
    },
    {
      path: 'bot',
      name: `${pre}bot`,
      component: () => import('@/views/robot/bot/manage'),
      meta: {
        title: '机器人管理'
      }
    },
    {
      path: 'groupchat',
      name: `${pre}groupchat`,
      component: () => import('@/views/robot/groupchat/index'),
      meta: {
        title: '群聊管理'
      }
    },
    {
      path: 'welcome',
      name: `${pre}welcome`,
      component: () => import('@/views/robot/welcome/index'),
      meta: {
        title: '入群欢迎'
      }
    },
    {
      path: 'autoreply',
      name: `${pre}autoreply`,
      component: () => import('@/views/robot/autoreply/index'),
      meta: {
        title: '自动回复'
      }
    },
    {
      path: 'circle',
      name: `${pre}circle`,
      component: () => import('@/views/robot/circle/index'),
      meta: {
        title: '朋友圈管理'
      }
    },
    {
      path: 'batchmsg/send',
      name: `${pre}batchmsg/send`,
      component: () => import('@/views/robot/batchmsg/send'),
      meta: {
        title: '消息群发'
      }
    },
    {
      path: 'batchmsg/index',
      name: `${pre}batchmsg/index`,
      component: () => import('@/views/robot/batchmsg/index'),
      meta: {
        title: '发送记录'
      }
    },

    {
      path: 'invite',
      name: `${pre}invite`,
      component: () => import('@/views/robot/invite/index'),
      meta: {
        title: '自动邀请'
      }
    },
    {
      path: 'notice/send',
      name: `${pre}notice/send`,
      component: () => import('@/views/robot/notice/send'),
      meta: {
        title: '发布公告'
      }
    },
    {
      path: 'notice',
      name: `${pre}notice`,
      component: () => import('@/views/robot/notice'),
      meta: {
        title: '历史公告'
      }
    },
    {
      path: 'kick',
      name: `${pre}kick`,
      component: () => import('@/views/robot/kick/index'),
      meta: {
        title: '自动踢人'
      }
    },
    {
      path: 'kick/blacklist',
      name: `${pre}kick/blacklist`,
      component: () => import('@/views/robot/kick/blacklist'),
      meta: {
        title: '黑名单'
      }
    },
    {
      path: 'groupchat/admin',
      name: `${pre}groupchat/admin`,
      component: () => import('@/views/robot/groupchat/admin'),
      meta: {
        title: '黑名单'
      }
    }
  ])('robot-')
}
